import { render } from "./UseResourceBonusRes.vue?vue&type=template&id=8438be66"
import script from "./UseResourceBonusRes.vue?vue&type=script&lang=js"
export * from "./UseResourceBonusRes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/hero/windowOverlay/UseResourceBonusRes.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8438be66"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8438be66', __exports__)) {
    api.reload('8438be66', __exports__)
  }
  
  module.hot.accept("./UseResourceBonusRes.vue?vue&type=template&id=8438be66", () => {
    api.rerender('8438be66', render)
  })

}


export default __exports__